import { z } from 'zod'

export const registerNewClient = z
  .object({
    editar_endereco: z.boolean(),
    name: z.string().nonempty(),
    email: z.string(),
    cellphoneClient: z
      .string()
      .nonempty()
      .transform((value) => value.replace(/\D/g, '')),
    phoneClient: z
      .string()
      .nonempty()
      .transform((value) => value.replace(/\D/g, '')),
    origin: z.object({
      value: z.string().nonempty(),
      label: z.string().nonempty(),
    }),

    personType: z.object({
      value: z
        .string()
        .nonempty()
        .transform((value) => (value === 'Pessoa Jurídica' ? 'J' : 'F')),
      label: z.string().nonempty(),
    }),
    cnpjCpf: z
      .string()
      .nonempty()
      .transform((value) => value.replace(/\D/g, '')),
    specialClient: z.boolean(),
    partnerName: z.string().nonempty(),
    socialReason: z.string().optional(),
    stateRegistration: z.string().optional(),
    icmsClassification: z.object({
      value: z.string().nonempty(),
      label: z.string().nonempty(),
    }),
    contract: z.string().optional(),
    cep: z
      .string()
      .nonempty()
      .transform((value) => value.replace(/\D/g, '')),
    street: z.string().nonempty(),
    number: z.string().nonempty(),
    complement: z.string().optional(),
    neighborhood: z.string().nonempty(),
    city: z.string().nonempty(),
    state: z.string().nonempty(),
    numero_contrato: z.string().optional(),

    phoneAddress: z
      .string()
      .transform((value) => value.replace(/\D/g, ''))
      .optional(),

    branch: z.string().optional(),
    contatos: z.array(
      z.object({
        nome: z.string().nonempty(),
        telefone: z
          .string()
          .nonempty()
          .transform((value) => value.replace(/\D/g, '')),
        email: z.string(),
        id_contato: z.string(),
        celular: z
          .string()
          .nonempty()
          .transform((value) => value.replace(/\D/g, '')),
        cargo: z.string().optional(),
        departamento: z.string().optional(),
      })
    ),
    emails: z
      .array(
        z.object({
          email: z.string(),
        })
      )
      .optional(),
  })
  .superRefine((data) => {
    //see tiver CNpj, a razão social é obrigatória
    if (data.personType.value === 'Pessoa Jurídica' && !data.socialReason) {
      return { socialReason: 'Campo obrigatório' }
    }

    return {}
  })
  .superRefine((data, customError) => {
    const contatos = data.contatos.map((contato) => contato.telefone)

    if (contatos.length === 0) {
      customError.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['contatos'],
        message: 'Adicione pelo menos um contato',
      })
    }

    return {}
  })
